import { Col, Form, Row } from "react-bootstrap";

interface IEpaField {
  label: string;
  value: string;
  labelClassName?: string;
  valueClassName?: string;
}

const EpaFieldHtml = ({
  label,
  value,
  labelClassName,
  valueClassName,
}: IEpaField) => {
  if (!labelClassName) labelClassName = "col-4 col-md-4";

  if (!valueClassName) valueClassName = "col-8 col-md-8";

  return (
    <Row className="mb-3">
      <Col className={labelClassName}>
        <Form.Label>{label}</Form.Label>
      </Col>
      <Col className={valueClassName}>
        <div dangerouslySetInnerHTML={{ __html: value }}></div>
      </Col>
    </Row>
  );
};

export default EpaFieldHtml;
